export default function FormCheckbox({
    label,
    name,
    checked,
    onChange,
    required = false,
    className = "",
    ...props
}) {
    return (
        <label className={`form-check d-flex gap-2 align-items-center ${className}`}>
            <input
                className="form-check-input"
                type="checkbox"
                name={name}
                checked={checked}
                onChange={onChange}
                {...props}
            />
            {label} {required && <span style={{ color: "red" }}>*</span>}
        </label>
    );
}